import React from 'react'
import LanguageComponent from '../language-selector/language.component';
// images
const logo = require('../../images/white-logo.svg');
// styles
const styles = require('./pre-acceptance-header.scss');


interface IProps {
  languageCode: string;
  handleLanguageChange: any;
}

class NewHeaderComponent extends React.Component<IProps> {
  render () {
    return (
        <header className={styles.header}>
        <div className={styles.logo}>
        <img src={logo} alt='header logo' />
        </div>
        <div className={styles.lang}>
        <LanguageComponent selectedLanguage={this.props.languageCode}
        handleLanguageChange={this.props.handleLanguageChange} />
        </div>
        </header>
        )
  }
}

export default NewHeaderComponent;



// WEBPACK FOOTER //
// ./src/components/new-header/new-header.component.tsx